module.exports = __webpack_public_path__ + "static/media/32_tn.4e5d406a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/32_tn.jpg
// module id = 245
// module chunks = 0